<mat-dialog-title *ngIf="ProcessID" class="dialog-title">
  <h2>Filtro de candidatos</h2>
  <mat-icon mat-dialog-close>cancel</mat-icon>
</mat-dialog-title>

<ng-container *ngIf="ProcessID; else noProcessIdContent">
  <mat-dialog-content>
    <div class="content">

      <div class="top-controls">
        <button mat-stroked-button color="accent" [matBadge]="candidatesRejectedLength"
          (click)="clearRejectCandidates()" [matBadgeHidden]="candidatesRejectedLength === 0"
          [disabled]="candidatesRejectedLength === 0" matBadgePosition="below" matBadgeColor="accent">
          Limpar lista de candidatos rejeitados
        </button>

        <button mat-stroked-button color="primary" [matBadge]="processListLength"
          [matBadgeHidden]="processListLength === 0" (click)="openProcessList()" [disabled]="processListLength === 0"
          matBadgePosition="below" matBadgeColor="accent" style="margin-left: 1%">
          <mat-icon>how_to_reg</mat-icon>
          Incluir Candidatos
        </button>
      </div>

      <div class="controls">
        <button mat-raised-button color="primary" (click)="openFilterDialog()" [disabled]="processStatus == 'finished' || (currentUser.signature_status !== 'ACTIVE' || currentUser.signature_status !== 'TRIAL')">
          Abrir filtro
        </button>
        <button mat-raised-button color="warn" (click)="clearFilters()"
          [disabled]="hasFilter() === false || processStatus === 'finished'">
          Limpar resultados
        </button> 
      </div>
      <div class="table-container">
        <form [formGroup]="filterForm" (submit)="submitFilter()">
          <div class="row">
            <mat-form-field appearance="outline" class="small">
              <mat-label>Digite para filtrar os resultados</mat-label>

              <input matInput type="text" formControlName="keyword" />
              <button mat-icon-button matPrefix type="submit" color="primary">
                <mat-icon>search</mat-icon>
              </button>
              <button mat-icon-button matSuffix type="reset" color="accent" (click)="resetFilter()"
                *ngIf="filterForm.dirty">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </form>

        <div class="responsive-table">
          <table class="table" mat-table [dataSource]="dataSource">
            <ng-container *ngFor="let attr of displayedColumns">
              <ng-container *ngIf="attr === 'options'; else options">
                <ng-container [matColumnDef]="attr">
                  <th mat-header-cell *matHeaderCellDef [ngStyle]="columnsStyle[attr]">
                    <mat-checkbox color="primary" [checked]="hasAllSelected()"
                      [disabled]="dataSource.data?.length === 0" [indeterminate]="isIndetermiteSelected()"
                      (change)="onSelectionAllChange($event)"></mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox color="primary" [value]="element" [disabled]="disabledCheckbox(element.id)"
                      [checked]="hasSelected(element.id)" (change)="selectChange($event)"></mat-checkbox>
                  </td>
                </ng-container>
              </ng-container>
              <ng-template #options>
                <ng-container *ngIf="attr !== 'resume'">
                  <ng-container [matColumnDef]="attr">
                    <th mat-header-cell *matHeaderCellDef [ngStyle]="columnsStyle[attr]">
                      <span class="th-wrapper">
                        {{ columnsDisplayName[attr] }}
                        <span class="order-by" *ngIf="getOrderBy(attr)">
                          <span *ngIf="getOrderBy(attr) == 'asc'" (click)="orderBy(attr, 'desc')"
                            matTooltip="Ordernar para baixo">
                            <mat-icon>arrow_drop_down</mat-icon>
                          </span>
                          <span *ngIf="getOrderBy(attr) == 'desc'" (click)="orderBy(attr, 'asc')"
                            matTooltip="Ordernar para cima">
                            <mat-icon>arrow_drop_up</mat-icon>
                          </span>
                        </span>
                        <span class="order-by" *ngIf="
                          getOrderBy(attr) == false &&
                          this.dataSource.data.length > 0
                        " (click)="orderBy(attr, 'desc')" matTooltip="Ordernar para baixo">
                          <span>
                            <mat-icon>arrow_drop_down</mat-icon>
                          </span>
                        </span>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="openCandidateInfo(element)">
                      {{ element[attr] }}
                    </td>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="attr === 'resume'">
                  <ng-container [matColumnDef]="attr">
                    <th mat-header-cell *matHeaderCellDef [ngStyle]="columnsStyle[attr]"></th>
                    <td mat-cell *matCellDef="let element" (click)="openCandidateInfo(element)">
                      <button mat-button color="primary" [mdePopoverOffsetX]="120" mdePopoverPositionY="above"
                        (mouseenter)="setCurrentTooltip(element.tooltip$)" [mdePopoverTriggerFor]="candidatePopover"
                        mdePopoverTriggerOn="hover" #popoverTrigger="mdePopoverTrigger">
                        Experiências
                      </button>
                    </td>
                  </ng-container>
                </ng-container>
              </ng-template>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" style="cursor: pointer"
              [ngClass]="{ rejected: processList.hasCandidateRejected(row.id) }"></tr>
          </table>
        </div>

        <ng-container *ngIf="dataSource.data && dataSource.data.length === 0 && !submiting">
          <div class="empty-content">
            <span class="mat-body-2" style="text-align: center;">
              Aplique os filtros para aparecer os resultados aqui
            </span>
          </div>
        </ng-container>
      </div>

      <mat-paginator [disabled]="submiting || dataSource.data.length == 0" [pageSizeOptions]="[20, 50, 100]"
        (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
    </div>

    <mde-popover #candidatePopover="mdePopover" [mdePopoverOverlapTrigger]="true">
      <mat-card style="min-width: 500px" class="mat-elevation-z3">
        <mat-card-content>
          <ng-container *ngIf="currentTooltip">
            <ul *ngIf="currentTooltip.length > 0">
              <ng-container *ngFor="let item of currentTooltip">
                <li>
                  <small>{{ item }}</small>
                </li>
              </ng-container>
            </ul>
            <div class="empty-content" *ngIf="currentTooltip.length == 0">
              <p class="mat-body">Sem experiências</p>
            </div>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </mde-popover>
  </mat-dialog-content>
</ng-container>

<ng-template #noProcessIdContent>
  <div class="content">
    <span class="mat-title">Filtro de candidatos</span>

    <div class="top-controls">
      <button mat-stroked-button color="accent" [matBadge]="candidatesRejectedLength" (click)="clearRejectCandidates()"
        [matBadgeHidden]="candidatesRejectedLength === 0" [disabled]="candidatesRejectedLength === 0"
        matBadgePosition="below" matBadgeColor="accent">
        Limpar lista de candidatos rejeitados
      </button>

      <button mat-stroked-button color="primary" [matBadge]="processListLength"
        [matBadgeHidden]="processListLength === 0" (click)="openProcessList()"
        [disabled]="processListLength === 0 || submitingCandidates == true" matBadgePosition="below"
        matBadgeColor="accent" style="margin-left: 1%">
        <mat-icon>how_to_reg</mat-icon>
        Incluir Candidatos
        <div *ngIf="submitingCandidates" style="float: right; margin-top: 6px; margin-left: 5px;">
          <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
        </div>
      </button>
    </div>

    <div class="controls">
      <button mat-raised-button color="primary" (click)="openFilterDialog()" [disabled]="processStatus == 'finished' || (currentUser.signature_status !== 'ACTIVE' && currentUser.signature_status !== 'TRIAL')">
        Abrir filtro
      </button>
      <button mat-raised-button color="warn" (click)="clearFilters()"
        [disabled]="hasFilter() === false || processStatus === 'finished'">
        Limpar resultados
      </button>
      <button mat-raised-button color="warn" (click)="openSearchDialog()"
      [disabled]="processStatus == 'finished' || (currentUser.signature_status !== 'ACTIVE' && currentUser.signature_status !== 'TRIAL')" 
      matTooltip="Adicionar Candidatos Manualmente">
          <mat-icon>group_add</mat-icon>
        </button>
    </div>
    <div class="table-container">
      <form [formGroup]="filterForm" (submit)="submitFilter()">
        <div class="row">
          <mat-form-field appearance="outline" class="small">
            <mat-label>Digite para filtrar os resultados</mat-label>

            <input matInput type="text" formControlName="keyword" />
            <button mat-icon-button matPrefix type="submit" color="primary">
              <mat-icon>search</mat-icon>
            </button>
            <button mat-icon-button matSuffix type="reset" color="accent" (click)="resetFilter()"
              *ngIf="filterForm.dirty">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </form>

      <table class="table" mat-table [dataSource]="dataSource">
        <ng-container *ngFor="let attr of displayedColumns">
          <ng-container *ngIf="attr === 'options'; else options">
            <ng-container [matColumnDef]="attr">
              <th mat-header-cell *matHeaderCellDef [ngStyle]="columnsStyle[attr]">
                <ng-container>
                  <mat-checkbox color="primary" [checked]="hasAllSelected()" [disabled]="dataSource.data?.length === 0"
                    [indeterminate]="isIndetermiteSelected()" (change)="onSelectionAllChange($event)"></mat-checkbox>
                </ng-container>
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="!submiting">
                  <mat-checkbox color="primary" [value]="element" [disabled]="disabledCheckbox(element.id)"
                    [checked]="hasSelected(element.id)" (change)="selectChange($event)"></mat-checkbox>
                </ng-container>
                <ng-container *ngIf="submiting">
                  <div style="width: 100%; padding-top: 20px;">
                    <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
                  </div>
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
          <ng-template #options>
            <ng-container *ngIf="attr !== 'resume'">
              <ng-container [matColumnDef]="attr">
                <th mat-header-cell *matHeaderCellDef [ngStyle]="columnsStyle[attr]">
                  <span class="th-wrapper">
                    {{ columnsDisplayName[attr] }}
                    <span class="order-by" *ngIf="getOrderBy(attr)">
                      <span *ngIf="getOrderBy(attr) == 'asc'" (click)="orderBy(attr, 'desc')"
                        matTooltip="Ordernar para baixo">
                        <mat-icon>arrow_drop_down</mat-icon>
                      </span>
                      <span *ngIf="getOrderBy(attr) == 'desc'" (click)="orderBy(attr, 'asc')"
                        matTooltip="Ordernar para cima">
                        <mat-icon>arrow_drop_up</mat-icon>
                      </span>
                    </span>
                    <span class="order-by" *ngIf="
                      getOrderBy(attr) == false &&
                      this.dataSource.data.length > 0
                    " (click)="orderBy(attr, 'desc')" matTooltip="Ordernar para baixo">
                      <span>
                        <mat-icon>arrow_drop_down</mat-icon>
                      </span>
                    </span>
                  </span>
                </th>
                <td mat-cell *matCellDef="let element" (click)="openCandidateInfo(element)">
                  <ng-container *ngIf="!submiting">
                    {{ element[attr] }}
                  </ng-container>
                  <ng-container *ngIf="submiting">
                    <div style="width: 100%; padding-top: 20px;">
                      <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
                    </div>
                  </ng-container>
                </td>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="attr === 'resume'">
              <ng-container [matColumnDef]="attr">
                <th mat-header-cell *matHeaderCellDef [ngStyle]="columnsStyle[attr]"></th>
                <td mat-cell *matCellDef="let element" (click)="openCandidateInfo(element)">
                  <ng-container *ngIf="!submiting">
                    <button mat-button color="primary" [mdePopoverOffsetX]="120" mdePopoverPositionY="above"
                      (mouseenter)="setCurrentTooltip(element.tooltip$)" [mdePopoverTriggerFor]="candidatePopover"
                      [mdePopoverEnterDelay]="500" [mdePopoverOffsetX]="-490" mdePopoverTriggerOn="hover"
                      #popoverTrigger="mdePopoverTrigger">
                      Experiências
                    </button>
                  </ng-container>
                  <ng-container *ngIf="submiting">
                    <div style="width: 100%; padding-top: 20px;">
                      <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
                    </div>
                  </ng-container>
                </td>
              </ng-container>
            </ng-container>
          </ng-template>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" style="cursor: pointer"
          [ngClass]="{ rejected: processList.hasCandidateRejected(row.id) }"></tr>
      </table>

      <ng-container *ngIf="!submiting && dataSource.data.length == 0">
        <div class="empty-content">
          <p class="mat-body-2">Nenhum resultado encontrado, faça um novo filtro</p>
        </div>
      </ng-container>

      <ng-container *ngIf="submiting && dataSource.data.length == 0">
        <div class="empty-content">
          <mat-progress-spinner diameter="40" mode="indeterminate"
            *ngIf="processStatus !== 'finished'"></mat-progress-spinner>
        </div>
      </ng-container>
    </div>

    <mat-paginator [disabled]="submiting || dataSource.data.length == 0" [pageSizeOptions]="[20, 50, 100]"
      (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
  </div>

  <mde-popover #candidatePopover="mdePopover" [mdePopoverOverlapTrigger]="true">
    <mat-card style="max-width: 450px" class="mat-elevation-z3">
      <mat-card-content>
        <ng-container *ngIf="currentTooltip">
          <ul *ngIf="currentTooltip.length > 0">
            <ng-container *ngFor="let item of currentTooltip">
              <li>
                <small>{{ item }}</small>
              </li>
            </ng-container>
          </ul>
          <div class="empty-content" *ngIf="currentTooltip.length == 0">
            <p class="mat-body">Sem experiências</p>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </mde-popover>
</ng-template>

<mat-dialog-actions *ngIf="ProcessID">
  <button mat-button color="warn" mat-dialog-close>Voltar</button>
</mat-dialog-actions>